<template>
  <div class="electionLeader">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">在线竞价</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ ProjectName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="right_content">
      <div class="title1">
        倒计时：<b>{{ day }}</b
        >天<b>{{ hr }}</b> 小时 <b>{{ min }}</b> 分 <b>{{ sec }}</b> 秒
      </div>
      <div id="BJCAPdfDiv"></div>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnEditQuote()">上一步</span>
        <span class="btn_1" @click="fnStartReview()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filePath: '',
      OperationId: this.$route.query.OperationId,
      QuotationFileId: this.$route.query.QuotationFileId,
      ProjectName: this.$route.query.ProjectName,
      EvaluationEndTime: this.$route.query.EvaluationEndTime,
      IsQuote: this.$route.query.IsQuote,
      SchemeId: this.$route.query.SchemeId,
      fileBase64: '',

      NowTime: 0,
      day: 0,
      hr: 0,
      min: 0,
      sec: 0
    }
  },
  mounted() {
    this.getdata()
  },
  methods: {
    getdata() {
      let config = {
        params: {
          QuotationFileId: this.QuotationFileId
        }
      }

      this.getRequest('Purchase/GetOnlineBiddingTender', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.filePath = res.data.filePath
            this.NowTime = new Date(res.data.nowTime).getTime()
            this.countdown()
            let that = this
            setTimeout(() => {
              this.initBjCA()
            }, 1000)
            window.addEventListener(
              'message',
              function (e) {
                if (e.origin != 'https://127.0.0.1:21061' && e.origin != 'http://127.0.0.1:21051') return
                var message = e.data
                if (message.type == 'signPdfBase64') {
                  that.setfileBase64(message.contents)
                }
              },
              false
            )
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnEditQuote() {
      let routerData = this.$router.resolve({
        name: 'EditOnlineBidding',
        query: {
          SchemeId: this.SchemeId,
          ProjectName: this.ProjectName,
          IsQuote: this.IsQuote
        }
      })
      window.open(routerData.href, '_blank')
      setTimeout(() => {
        window.close()
      }, 1000)
    },
    countdown: function () {
      let interval = setInterval(() => {
        //定义this指向
        const that = this
        that.NowTime = that.NowTime + 1000
        //设置结束时间
        const end = new Date(that.EvaluationEndTime).getTime()
        //设置开始时间
        const now = that.NowTime

        // 做判断当倒计时结束时都为0
        if (now >= end) {
          that.day = 0
          that.hr = 0
          that.min = 0
          that.sec = 0
          return
        }
        // 用结束时间减去当前时间获得倒计时时间戳
        const msec = end - now
        let day = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
        let hr = parseInt((msec / 1000 / 60 / 60) % 24) //算出小时数
        let min = parseInt((msec / 1000 / 60) % 60) //算出分钟数
        let sec = parseInt((msec / 1000) % 60) //算出秒数
        //给数据赋值
        that.day = day
        that.hr = hr > 9 ? hr : '0' + hr
        that.min = min > 9 ? min : '0' + min
        that.sec = sec > 9 ? sec : '0' + sec

        //使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
      }, 1000)
    },
    setfileBase64(contents) {
      this.$message({
        type: 'success',
        message: '签字成功!'
      })
      this.fileBase64 = contents
    },
    fnStartReview() {
      var isSubmit = true
      if (this.fileBase64 == '') {
        this.$message.error('请先完成签名再提交！')
        isSubmit = false
        return
      }
      if (isSubmit) {
        this.postRequest('Purchase/SaveOnlineBiddingTender', {
          operationId: this.OperationId,
          fileBase64: this.fileBase64
        }).then((res) => {
          if (res.data.errcode == 0) {
            localStorage.setItem('OnlineBiddingList', Math.random())
            this.fnBiddingRoom(this.SchemeId, this.ProjectName, false)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    fnBiddingRoom(SchemeId, ProjectName, IsNewSupplier) {
      if (IsNewSupplier == true) {
        let routerData = this.$router.resolve({
          name: 'OnlineBiddingNotice',
          query: {
            SchemeId: SchemeId,
            ProjectName: ProjectName
          }
        })
        window.open(routerData.href, '_blank')
      } else {
        let routerData = this.$router.resolve({
          name: 'OnlineBiddingRoom',
          query: {
            SchemeId: SchemeId,
            ProjectName: ProjectName
          }
        })
        window.open(routerData.href, '_blank')
        setTimeout(() => {
          window.close()
        }, 1000)
      }
    },
    initBjCA() {
      window.console.log(this.baseURL + this.filePath)
      var height = document.documentElement.clientHeight - 250 + 'px'
      var width = document.documentElement.clientWidth - 20 + 'px'
      var savePath = 'C:\\gyc.pdf'
      var saveType = 'net'
      var token = '123456'
      var h1 = document.documentElement.clientHeight - 310
      var w1 = document.documentElement.clientWidth - 430
      document.getElementById('BJCAPdfDiv').innerHTML =
        '<iframe src="http://127.0.0.1:21051/PDFClient/viewer.html?fileUrl=' +
        this.baseURL +
        this.filePath +
        '&savePath=' +
        savePath +
        '&saveType=' +
        saveType +
        '&token=' +
        token +
        '" id="BJCAPdfJsViewer" frameborder="0" scrolling="auto" width="' +
        width +
        '" height="' +
        height +
        '"></iframe>'
      // var ifm2 = document.getElementById("BJCAPdfJsViewer");
      // ifm2.height = document.documentElement.clientHeight - 6;
    }
  }
}
</script>
<style lang="scss" scoped>
.title1 {
  padding: 10px 0;
  background-color: #f9f9d2;
  text-align: center;
  color: #ff6600;
  font-size: 16px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #f60;
    border: 1px solid #f60;
    color: #fff;
    border-radius: 8px;
  }

  .btn_1:nth-of-type(1) {
    margin-right: 30px;
  }
}
</style>